import React, {useState} from "react";
import { useHistory } from "react-router-dom";
import { AssetsReport } from "./AssetsDashboardComponents/AssetsReport";
import { AssetsTable } from "./AssetsDashboardComponents/AssetsTable";
import "./AssetsDashboard.css";

export const AssetsDashboard = () => {
  const history = useHistory();
  const [sharedState, setSharedState] = useState(false);
  const updateSharedState = (newState) => {
    setSharedState(newState);
  };
  return (
    <div className="AssetsMain">
      <div className="assetscreate">
        <button
          className="addbuttonassets"
          onClick={() => {
            history.push("/asset_allocation");
          }}
        >
          {" "}
          + Add Asset
        </button>
      </div>
      <div className="AssetsMainReport">
        <AssetsReport 
          sharedState={sharedState}
          updateSharedState={updateSharedState}
         />
      </div>
      <div className="assetsTableCard">
        <AssetsTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
         />
      </div>
    </div>
  );
};